import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { Investment } from '../../generated/graphql';

export interface InvestmentSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'contentPrefix' | 'motionProps'
  > {
  itemTitle?: string;
  investment: Investment;
  onItemClicked?: (a: { investment: Investment }) => void;
}

export const InvestmentSumTableItem = ({ investment, onItemClicked, ...props }: InvestmentSumTableItemProps) => {
  return (
    <AmountSumTableItem
      linkStatus={investment.linkStatus}
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      key={investment.id}
      title={props.itemTitle ?? investment.name}
      dataTestID={investment.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      amount={investment.ownedValue}
      className={props.className}
      onClick={() => onItemClicked?.({ investment })}
      lastUpdated={latestDataPointGroupUpdateDateTime(investment.value)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ investment })}
      decayed={isDecayed(latestDataPointGroupUpdateDate(investment.value), decayedLimit.Investment)}
    />
  );
};
